export default __webpack_public_path__ + "static/media/icons-web-select.5071d5bf.svg";